module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 373
// module chunks = 2